module.exports = __webpack_public_path__ + "media/images/email_second-1b0dedc10b2c1cb82709451b3cadbe3b.svg";